import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import PipeProvider from 'Services/Providers/PipeProvider';
import { useSelector } from 'react-redux';

const CepContext = createContext({
  cep: null,
  isLoading: false,
  isLoaded: false,
  data: null,
  isError: false,
  setIsLoading: (value) => { },
  setCep: (value) => { },
  setIsError: (value) => { },
})

export const useCepProvider = () => useContext(CepContext)

const Provider = ({ children }) => {
  const Shipping = useSelector(({ Shipping: data }) => {
    return data
  })
  const [cep, setCep] = useState(null)
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  const [isError, setIsError] = useState(false)

  const Value = useMemo(() => ({
    cep,
    data,
    isLoading,
    isLoaded,
    isError,
    setCep(cep) { setCep(cep) },
    setData(data) { setData(data) },
    setIsLoading(status) { setIsLoading(status) },
    setIsLoaded(status) { setIsLoaded(status) },
    setIsError(status) { setIsError(status) },
  }), [cep, data, isLoading, isLoaded, isError])

  useEffect(() => {
    if (Shipping && Shipping.filled && Shipping.value) {
      if (!Shipping.isLoading) {
        setIsLoaded(true)
        setIsLoading(false)
        setData(Shipping.value)
      }
    }
    if (Shipping && !Shipping.filled && !Shipping.value || Shipping.isError) {
      setIsLoaded(true)
      setIsLoading(false)
      setIsError(true)
    }
  }, [Shipping]);

  return (
    <CepContext.Provider value={Value}>
      <PipeProvider>
        {children}
      </PipeProvider>
    </CepContext.Provider>
  )
}

export default Provider;